export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8519.13e4ea42.jpg";